import {
  //   doc,
  //   getDocs,
  //   updateDoc,
  collection,
  //   setDoc,
  //   deleteField,
  addDoc,
  //   deleteDoc,
  //   query,
  //   where,
  // onSnapshot,
  // orderBy,
} from "firebase/firestore";

import { db } from "../firebase";

export const guestRSVP = async ({
  guestId,
  status,
  name,
  eventId,
  companyId,
  guestsInvited,
  kosherFood,
  needRide,
  isHealthy,
}) => {
  const payloadObj = {
    guestId,
    name,
    eventId,
    companyId,
    guestsInvited,
    status,
    updated: new Date(),
    kosherFood,
    needRide,
    isHealthy,
    guestRecordUpdated: false,
  };
  try {
    let result = await addDoc(collection(db, "rsvpHistory"), payloadObj);
    if (result) {
      return true;
    }
  } catch (err) {
    console.error(err);
    return false;
  }
};
